import { atom } from 'jotai'

// Primary balance atom — single source of truth for displayed wallet balance
export const walletBalanceAtom = atom(null) // null = not yet loaded

// Derived read-only: formatted amount (number) from the atom
export const balanceAmountAtom = atom((get) => {
  const wallet = get(walletBalanceAtom)
  return parseFloat(wallet?.amount || 0)
})

// Sync status: 'idle' | 'syncing' | 'error'
export const balanceSyncStatusAtom = atom('idle')

// Timestamp of last successful balance fetch (ms)
export const lastBalanceFetchAtom = atom(0)
